import { Link } from "react-router-dom"
import type { Profile } from "@/nostr/types"
import { npubOf } from "@/utils/nip19"
import { shortNpub } from "@/utils/nip19"

export function profilePath(pubkey: string): string {
  return `/u/${npubOf(pubkey)}`
}

export interface UserNameProps {
  pubkey: string
  profile?: Profile
  className?: string
  /** Shows the handle below the name (used in cards). */
  showHandle?: boolean
}

/** Display name linking to the profile, with a compact npub fallback. */
export function UserName({ pubkey, profile, className = "", showHandle = false }: UserNameProps) {
  const name = profile?.displayName || profile?.name
  const handle = profile?.nip05 || shortNpub(pubkey)
  return (
    <Link to={profilePath(pubkey)} className={`user-name ${className}`} title={handle}>
      <span className="user-name-main">{name || shortNpub(pubkey)}</span>
      {showHandle && <span className="user-name-handle">{handle}</span>}
    </Link>
  )
}

export function ProfileLink({ pubkey, profile }: UserNameProps) {
  const name = profile?.displayName || profile?.name || shortNpub(pubkey)
  return <Link to={profilePath(pubkey)}>{name}</Link>
}
